import { useContext } from 'react';
import { StoreContext } from '@roc/client-portal-shared/context';
import { RocInternalPortalStore } from '../stores';

export const useRocInternalPortalStore = () =>
  useContext<RocInternalPortalStore>(StoreContext);
